import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { Agency } from "src/app/shared/types/user-types";

@Injectable({
  providedIn: "root",
})
export class AgencyService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getAgency(): Observable<Agency> {
    return this.http.get<Agency>(`${this.apiUrl}/api/agency`);
  }

  updateAgency(agency: Agency): Observable<Agency> {
    return this.http.put<Agency>(`${this.apiUrl}/api/agency`, agency);
  }

  updateAgencyEInvoiceToken(token: string): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/api/agency/e-invoice-token`, { token });
  }
}
